import styled, { css } from 'styled-components';

// @ts-ignore
import svg from './arrow.svg';

export const Wrapper = styled.div`
  width: fit-content;
  height: 30px;
  opacity: 0.2;
  transition: opacity 0.2s ease-in;
  cursor: pointer;
  
  :hover {
    opacity: 1;
  }
`;

export const ArrowSvg = styled.img.attrs({
    src: svg,
})<{ type?: 'left' | 'right' }>`
  height: 100%;
  ${({ type }) => type === 'right' && css`transform: rotate(180deg);`}
`;
